import { render, staticRenderFns } from "./NeedValidatePhysicians.vue?vue&type=template&id=39b8f866&scoped=true&"
import script from "./NeedValidatePhysicians.vue?vue&type=script&lang=js&"
export * from "./NeedValidatePhysicians.vue?vue&type=script&lang=js&"
import style0 from "./NeedValidatePhysicians.vue?vue&type=style&index=0&id=39b8f866&lang=scss&scoped=true&"
import style1 from "./NeedValidatePhysicians.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8f866",
  null
  
)

export default component.exports